// extracted by mini-css-extract-plugin
export default {"modal":"ModalRouter-Modal__modal--hYYOX"};